; (function () {
	'use strict';

	if (!customElements.get('ts-product-grid')) {
		class tsProductGrid extends HTMLElement {
			constructor() {
				super();
				this.slider = this.querySelector('.swiper');
				this.nextBtn = this.closest('.ts-product-grid')?.querySelector('.js-next');
				this.prevBtn = this.closest('.ts-product-grid')?.querySelector('.js-prev');
				this.swiper = null;
			}

			connectedCallback() {
				if (this.slider) {
					this.initSwiper();
				}

				window.addEventListener('resize', () => this.initSwiper.call(this));
			}
		}

		tsProductGrid.prototype.initSwiper = function () {
			const sliderInit = () => {

				this.swiper = new Swiper(this.slider, {
					loop: false,
					lazy: true,
					speed: 400,
					slidesPerView: 'auto',
					spaceBetween: 24,
					slidesOffsetAfter: 24,
					slidesOffsetBefore: 24,
					a11y: false,
					navigation: {
						nextEl: this.nextBtn,
						prevEl: this.prevBtn,
					},
					breakpoints: {
						320: {
							spaceBetween: 24
						},
						750: {
							slidesOffsetAfter: 62,
							slidesOffsetBefore: 62
						},
						1050: {
							spaceBetween: 32,
							slidesOffsetBefore: 0,
							slidesOffsetAfter: 62
						}
					}
				});
			}

			sliderInit();
		};

		customElements.define('ts-product-grid', tsProductGrid);
	}
	document.addEventListener("DOMContentLoaded", function () {
  const gallery = document.querySelector('.ts-gallery');

  if (!gallery || !gallery.swiper) return;

  const swiper = gallery.swiper;

  gallery.addEventListener('click', function () {
    swiper.slideNext();
  });
});
})()
